import { useMe } from '@core/hooks/use-me.js';
import { useReleaseToggle } from '@core/hooks/use-release-toggle.js';
import { createFileRoute, Navigate } from '@tanstack/react-router';

import { ReportWriterSection } from '../features/projects/detail/report-writer/report-writer-section.js';

function ReportWriterRoute() {
  const { teamId, projectId } = Route.useParams();
  const me = useMe();
  const enabled = useReleaseToggle('agent_sessions');
  // Fail closed only once /me resolved — the toggle reads false while loading.
  if (me.isLoading) return null;
  if (!enabled) {
    // A dark feature's deep link behaves like an unknown URL (the catch-all
    // route's redirect), matching the backend's 404.
    return <Navigate to="/login" replace />;
  }
  return <ReportWriterSection teamId={teamId} projectId={projectId} />;
}

export const Route = createFileRoute(
  '/_authed/teams/$teamId/projects/$projectId/report-writer',
)({
  component: ReportWriterRoute,
});
